export const CookieNames = {
  userEmail: '_user_data_email',
};
